import axios from 'axios';
import Vue from '../../node_modules/vue';
import parseCookie from './parseCookie';
import { getPlatform } from './ua';
import { Toast } from 'vant';
import {parseBetaUrl} from './beta';

// 配置统一的请求header
Vue.prototype.$axios = axios.create({
    xsrfCookieName: 'csrfToken',
    xsrfHeaderName: 'x-csrf-token',
    headers: {
        platform: getPlatform(),
    },
});

Vue.prototype.$axios.interceptors.request.use((config) => {
    const { token, x_use_ppe: xUsePPE, x_tt_env: xTTENV } = parseCookie(document.cookie);
    if (token) {
        config.headers.token = token; // eslint-disable-line
    }
    if (xUsePPE && xTTENV) {
        config.headers['x-use-ppe'] = xUsePPE;
        config.headers['x-tt-env'] = xTTENV;
    }
    return config;
});

Vue.prototype.$axios.interceptors.response.use(function (response) {
    response.data = parseBetaUrl(response.data);
    return response;
}, function (error) {
    return Promise.reject(error);
})

/**
 * 这里配置统一的响应中间件，会直接将响应数据返回给调用方；
 * 请求失败（响应码不为200），会自动弹出Toast；
 * 并且会检查响应的数据，如果result不为SUCCESS，也视为请求失败（也会自动弹出Toast）。
 */
Vue.prototype.$axios.interceptors.response.use((response) => {
    if (response.status == 200) {
        if (response.data.code == 1) {
            try {
                window.JSBridge.ready(() => {
                    window.JSBridge.login(() => {
                        window.location.reload();
                    });
                });
            } catch (error) {
                Toast(`JSB调用失败` + error, {
                    duration: 2000,
                });
            }
            return Promise.reject(response);
        }
        // debugger;
        if (!response.data.code || response.data.code == 0) {
            return response.data;
        }
        if (!response.config.hideToast) {
            Toast(response.data.message, {
                duration: 2000,
            });
        }
    } else 
    return Promise.reject(response);
}, (error) => {
    if (!error.config.hideToast) {
        Toast('网络错误，请重试', {
            duration: 2000,
        });
    }
    return Promise.reject(error);
});

export default Vue.prototype.$axios;
